import { Typography } from '@crossnokaye/ux-common';

interface EmptyStatePlaceholderProps {
  message?: string;
}

export const EmptyStatePlaceholder = ({
  message = 'Nothing to display',
}: EmptyStatePlaceholderProps): React.ReactNode => {
  return (
    <div className="flex items-center justify-center rounded-md bg-muted/50 p-8">
      <Typography variant="body" className="text-muted-foreground">
        {message}
      </Typography>
    </div>
  );
};
